<template>
  <div class="py-4 container-fluid">
    <div class="row"></div>
    <div class="row">
      <div class="col-12">
        <!-- <projects-table /> -->
        <div class="row mspacer">
          <div class="card col-sm-12">
            <!--  -->
            <div class="card mborder">
              <div class="card mb-4">
                <div class="card-header pb-0">
                  <h6>Nearly Expiring Drugs / Items</h6>
                </div>
                <div class="card-body px-0 pt-0 pb-2">
                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Drug / Item
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                          >
                            Time-to-expiry
                          </th>
                          <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Traced-store(s)
                          </th>
                          <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Total-available-Quantity
                          </th>
                          <th class="text-secondary opacity-7"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in expiringStocks" :key="item.id">
                          <td>
                            <div class="d-flex px-2 py-1">
                              <!-- <div>
                                <soft-avatar
                                  :img="item.img || 'default-img-url'"
                                  size="sm"
                                  border-radius="lg"
                                  class="me-3"
                                  alt="item-image"
                                />
                              </div> -->
                              <div
                                class="d-flex flex-column justify-content-center"
                              >
                                <!-- <h6 class="mb-0 text-sm">
                                  {{ item.item_name }}
                                </h6>
                                <p class="text-xs text-secondary mb-0">
                                  {{ item.brand_name }} |
                                  {{ item.category_name }}
                                </p> -->
                                <ItemName
                                  :ItemName="item.item_name"
                                  :ItemBrand="item.brand_name"
                                  :ItemStrength="item.item_strength"
                                />
                              </div>
                            </div>
                          </td>
                          <td>
                            <p class="text-xs font-weight-bold mb-0">
                              {{ daysToExpiry(item.expiry_date) }}
                            </p>
                          </td>
                          <td class="align-middle text-center text-sm">
                            <soft-badge
                              color="success"
                              variant="gradient"
                              size="sm"
                            >
                              {{ item.store_name }}
                            </soft-badge>
                          </td>
                          <td class="align-middle text-center">
                            <span
                              class="text-secondary text-xs font-weight-bold"
                            >
                              {{ item.c_quantity }}
                            </span>
                          </td>
                          <td class="align-middle">
                            <a
                              href="javascript:;"
                              class="text-secondary font-weight-bold text-xs"
                              data-toggle="tooltip"
                              data-original-title="Edit"
                            >
                              No-action
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!--  -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ItemName from "./components/ItemName.vue";
import { generalApiRequest } from "../../api/apiIndex";

export default {
  name: "inventory",
  data() {
    return {
      expiringStocks: [],
    };
  },
  components: {
    ItemName,
  },
  mounted() {
    this.getExpiringStocks();
  },

  methods: {
    async getExpiringStocks() {
      try {
        const res = await generalApiRequest("stocks/expiring", "GET", {}, 1);
        console.log(res);

        this.expiringStocks = res.data.data;
      } catch (error) {
        console.error("Failed to fetch expiring stocks", error);
      }
    },
    daysToExpiry(expiryDate) {
      const expiry = new Date(expiryDate);
      const now = new Date();
      const timeDiff = expiry - now;
      const days = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return days <= 0 ? "Expired" : `${days} days`;
    },
  },
};
</script>

<style scoped>
.cardlink {
  padding: 1em;
  box-shadow: 5px 10px 8px rgba(0, 0, 0, 0.2);
}
.spacecols {
  padding-top: 0.5em;
  padding-bottom: 0.4em;
}
.mspacer {
  padding: 1em;
  border-radius: 1em;
}
.mborder {
  border: "1px solid grey";
}
.rbcgnd {
  background-color: rgb(224, 224, 224);
  /* margin-top:2em !important; */
  margin-right: 1em;
}
.fontlinks {
  font-weight: bold;
  color: black;
}
.righter {
  margin-left: auto !important;
}
a:hover {
  background-color: #98fc03;
}

.card h2 {
  margin-bottom: 10px;
  text-align: center;
}

.link-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-list li {
  margin-bottom: 5px;
  /* Add a border-bottom style here */
  border-bottom: 1px solid #ddd;
}

.link-list a {
  color: #333;
  text-decoration: none;
  display: block;
  padding: 10px 15px;
  transition: background-color 0.2s ease-in-out;
}

.link-list a:hover {
  background-color: #f5f5f5;
}
</style>
